export enum Permission {
  // Ingest Recieps CSV Permission
  CsvIngestionAccessConfiguration = 'basic.legacy_admin',
  AdminPanel = 'admin_panel.legacy_permission',
}
